<template>
    <div>

      <Breadtabsheader/>

        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2"style="margin-left:20px">
                                    <h1>基本信息</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine weekplandetail35">
                                        <el-form :model="add" v-if ="fromType==1" label-position="right" ref="bh" :inline="true"
                                                 class="demo-ruleForm h-formbLine h-formbLine1">

                                            <el-form-item  label="省" prop='province' class="h-elformWrap-2">
                                                <el-input v-model="add.province"   readonly>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item  label="城市" prop='city' class="h-elformWrap-2">
                                                <el-input v-model="add.city"   readonly>
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item  label="项目名称" prop='projectName' class="h-elformWrap-2">
                                                <el-input v-model="add.projectName"  >
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item  label="对应产业链群" prop='industry' class="h-elformWrap-2">
                                                <el-input v-model="add.industry"  >
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item  label="销售人员" prop='salesManName' class="h-elformWrap-2">
                                                <el-input v-model="add.salesManName"  >
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item  label="渠道名称" prop='channelName' class="h-elformWrap-2">
                                                <el-input v-model="add.channelName"  >
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item  label="线索来源" prop='clueFromName' class="h-elformWrap-2">
                                                <el-input v-model="add.clueFromName"  >
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item  label="用户单位" prop='userUnitName' class="h-elformWrap-2">
                                                <el-input v-model="add.userUnitName"  >
                                                </el-input>
                                            </el-form-item>


                                            <el-form-item  label="原文链接" prop='userRequire' class="h-elformWrap-1">
                                                <el-link v-if="isUrl(add.userRequire)" :href="add.userRequire" target="_blank"
                                                         type="primary">
                                                    {{ add.userRequire }}
                                                </el-link>
                                            </el-form-item>

                                            <el-form-item label="指派经销商" prop="salesman" class="h-elformWrap-2" v-if="add.taskType==4 ||add.taskType==5 || add.taskType==6" >
                                                <el-select v-model="this.salesManName" @change="salesmanChange($event)"
                                                           placeholder="指派经销商" style="width: 100%;">
                                                    <el-option
                                                        v-for="item in salesmanList"
                                                        :key="item.id"
                                                        :label="`${item.userName}(${item.userCode})`"
                                                        :value="item.userName">
                                                    </el-option>

                                                </el-select>
                                            </el-form-item>

                                        </el-form>
                                        <el-form :model="add" v-if ="fromType==2" label-position="right" ref="bh" :inline="true"
                                                 class="demo-ruleForm h-formbLine h-formbLine1">

                                            <el-form-item  label="省" prop='province' class="h-elformWrap-2">
                                                <el-input v-model="add.province"   readonly>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item  label="城市" prop='city' class="h-elformWrap-2">
                                                <el-input v-model="add.city"   readonly>
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item  label="线索名称" prop='projectName' class="h-elformWrap-2">
                                                <el-input v-model="add.projectName"  >
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item  label="产业" prop='yxIndustry' class="h-elformWrap-2">
                                                <el-input v-model="add.yxIndustry"  >
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item  label="销售人员" prop='salesManName' class="h-elformWrap-2">
                                                <el-input v-model="add.salesManName"  >
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item  label="渠道名称" prop='channelName' class="h-elformWrap-2">
                                                <el-input v-model="add.channelName"  >
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item  label="线索来源" prop='yxOriginalsource' class="h-elformWrap-2">
                                                <el-input v-model="add.yxOriginalsource"  >
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item  label="感兴趣的产品" prop='yxField6640' class="h-elformWrap-2">
                                                <el-input v-model="add.yxField6640"  >
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item  label="近期采购计划" prop='yxScrmmember39356' class="h-elformWrap-2">
                                                <el-input v-model="add.yxScrmmember39356"  >
                                                </el-input>
                                            </el-form-item>



                                            <el-form-item  label="原文链接" prop='userRequire' class="h-elformWrap-1">
                                                <el-link v-if="isUrl(add.userRequire)" :href="add.userRequire" target="_blank"
                                                         type="primary">
                                                    {{ add.userRequire }}
                                                </el-link>
                                            </el-form-item>



                                            <el-form-item label="指派经销商" prop="salesman" class="h-elformWrap-2" v-if="add.taskType==4 ||add.taskType==5 || add.taskType==6" >
                                                <el-select v-model="this.salesManName" @change="salesmanChange($event)"
                                                           placeholder="指派经销商" style="width: 100%;">
                                                    <el-option
                                                        v-for="item in salesmanList"
                                                        :key="item.id"
                                                        :label="`${item.userName}(${item.userCode})`"
                                                        :value="item.userName">
                                                    </el-option>

                                                </el-select>
                                            </el-form-item>

                                        </el-form>
                                        <el-form :model="add" v-if ="fromType==3" label-position="right" ref="bh" :inline="true"
                                                 class="demo-ruleForm h-formbLine h-formbLine1">

                                            <el-form-item  label="省" prop='province' class="h-elformWrap-2">
                                                <el-input v-model="add.province"   readonly>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item  label="城市" prop='city' class="h-elformWrap-2">
                                                <el-input v-model="add.city"   readonly>
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item  label="线索名称" prop='projectName' class="h-elformWrap-2">
                                                <el-input v-model="add.projectName"  >
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item  label="对应产业链群" prop='industry' class="h-elformWrap-2">
                                                <el-input v-model="add.industry"  >
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item  label="销售人员" prop='salesManName' class="h-elformWrap-2">
                                                <el-input v-model="add.salesManName"  >
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item  label="渠道名称" prop='channelName' class="h-elformWrap-2">
                                                <el-input v-model="add.channelName"  >
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item  label="线索来源" prop='clueFromName' class="h-elformWrap-2">
                                                <el-input v-model="add.clueFromName"  >
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item  label="归属公司" prop='ncCompany' class="h-elformWrap-2">
                                                <el-input v-model="add.ncCompany"  >
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item  label="产品类别" prop='ncProductCategory' class="h-elformWrap-2">
                                                <el-input v-model="add.ncProductCategory"  >
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item  label="联系人" prop='ncFullName' class="h-elformWrap-2">
                                                <el-input v-model="add.ncFullName"  >
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item  label="联系电话" prop='ncMobilePhone' class="h-elformWrap-2">
                                                <el-input v-model="add.ncMobilePhone"  >
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item  label="优惠码" prop='ncPromoCode' class="h-elformWrap-2">
                                                <el-input v-model="add.ncPromoCode"  >
                                                </el-input>
                                            </el-form-item>


                                            <el-form-item  label="原文链接" prop='userRequire' class="h-elformWrap-1">
                                                <el-link v-if="isUrl(add.userRequire)" :href="add.userRequire" target="_blank"
                                                         type="primary">
                                                    {{ add.userRequire }}
                                                </el-link>
                                            </el-form-item>



                                            <el-form-item label="指派经销商" prop="salesman" class="h-elformWrap-2" v-if="add.taskType==4 ||add.taskType==5 || add.taskType==6" >
                                                <el-select v-model="this.salesManName" @change="salesmanChange($event)"
                                                           placeholder="指派经销商" style="width: 100%;">
                                                    <el-option
                                                        v-for="item in salesmanList"
                                                        :key="item.id"
                                                        :label="`${item.userName}(${item.userCode})`"
                                                        :value="item.userName">
                                                    </el-option>

                                                </el-select>
                                            </el-form-item>

                                        </el-form>
                                    </div>
                                </div>
                            </div>


                            <div class="h-pieceTitle2 hang">

                                <div  v-if="(add.taskType==4 || add.taskType==5) && _user.usercode ==  add.salesManCode" class="h-txtCenter" style="margin-top: 0.3rem;">
                                    <el-button class="h-btn h-bBtn h-bgblueQ2"  @click="designatecommit">确定指派</el-button>
                                    <el-button class="h-btn h-bBtn h-bgblueQ2"  @click="undertake(2)">承接-无效信息</el-button>
                                    <el-button class="fanhui" @click="backL">返回</el-button>
                                </div>

                                <div v-if="(add.trackStatus == '' || add.trackStatus == null) &&_user.usercode ==  add.salesManCode && (add.taskType!=4 && add.taskType!=5  && add.taskType!=9)" class="h-txtCenter" style="margin-top: 0.3rem;">
                                    <el-button class="h-btn h-bBtn h-bgblueQ2"  @click="undertake(1)">承接-转商机</el-button>
                                    <el-button class="h-btn h-bBtn h-bgblueQ2"  @click="undertake(2)">承接-无效信息</el-button>
                                    <el-button class="h-btn h-bBtn h-bgred"  v-if="add.taskType==0" @click="undertake(3)">拒绝承接</el-button>
                                    <el-button class="fanhui" @click="backL">返回</el-button>
                                </div>



                            </div>
                        </div>
                    </div>


                </div>
            </div>



        </div>


  </div>
</template>


<script>
import ss from "../../../api/SystemService";
import _ from "loadsh";
export default {
    data() {
        return {
            id:null,

            fromType:"1",//用于区分 展会线索还是其他 1其他 2展会
            salesManName: '',
            salesManCode: '',
            add: {
                id: '',
                province: '',
                city: '',
                salesManName: '',
                salesManCode: '',
                channelCode: '',
                channelName: '',
                clueFrom: '',
                userUnitName: '',
                userUnitCode: '',
                clueFromName:'',
                proCategory: '',
                taskType:'',  //任务类型 1 员工待指派  2 员工待承接 3省区总待承接 4 管理员待承接
                userRequire: '',
                memo: '',
                chainGroup: '',
                chainCode: '',
                ids: [],  //checkbook 的 id
                trackStatus: '',
                assignType: '',//指派类型 1区域销售人员 2经销商
                fromSource:'',
                yxIndustry:'',//产业
                yxField6640:'',//感兴趣的产品
                yxScrmmember39356:'',//近期采购计划
                //新渠道
                ncCompany:'',//归属公司
                ncProductCategory:'',//产品类别
                ncFullName:'',//联系人
                ncMobilePhone:'',//联系电话
                ncDemandContent:'',//需求详情
                ncPromoCode:'',//优惠码
                yxOriginalsource:'',//新营销线索来源
            },
            shenglist: [],      //省份list
            salesmanList: [],  // 销售人员list
            cityList: [],      //城市list
            disabled :true,
        }
    },
    created() {
        this.id = this.$route.query.id;
        this.getById(this.id);
    },

    methods:{

        getById(id) {
            ss.BscClueZhaoBiao.selectById(id).then(rd => {
                console.log(rd);
                this.add = rd.obj
                if(this.add.fromSource=='MC_03'){
                    this.fromType ="2"; //2 表示展会线索
                }
                if(this.add.fromSource=='CH_01'){
                    this.fromType ="3"; //3 表示新渠道线索
                }

                this.selectClueAgentOwner();
            })
        },


        backL() {
            if(this.add.fromSource =='RTB_91' || this.add.fromSource =='RTB_93'){
                this.$router.push({ path: "/bscClueTabs", query: { type: "second"} });
            }
            if(this.add.fromSource =='PP_01' || this.add.fromSource =='PP_02'){
                this.$router.push({ path: "/bscClueTabs", query: { type: "third"} });
            }
            if(this.add.fromSource =='MC_03' ){
                this.$router.push({ path: "/bscClueTabs", query: { type: "fourth"} });
            }
            if(this.add.fromSource =='CH_01' ){
                this.$router.push({ path: "/bscClueTabs", query: { type: "fifth"} });
            }

        },

        isUrl(str) {
            if (typeof str !== 'string' || str.length === 0) {
                return false;
            }
            try {
                // 必须以 http:// 或 https:// 开头才视为有效链接（按业务需求）
                if (!str.startsWith('http://') && !str.startsWith('https://')) {
                    return false;
                }
                new URL(str); // 浏览器原生解析，高效且准确
                return true;
            } catch (e) {
                return false;
            }
        },

        salesmanChange(o) {
            this.salesManName = o;
        },

        //根据省查询对应的经销商
        selectClueAgentOwner() {

            var data  = {
                "province":this.add.province ,
                "city":this.add.city ,
            }
            ss.clueAgentOwner.selectClueAgentOwner(data).then(res => {

                this.salesmanList=[];
                for (var i = 0; i < res.obj.length; i++) {

                    var newdata = {
                        "id": res.obj[i].agentCode,
                        "userName":  res.obj[i].agentName,
                        "userCode": res.obj[i].agentCode
                    }
                    this.salesmanList.push(newdata);
                }
            })

        },
        //指派
        designatecommit() {


            if (!this.salesManName) {
                this.$message.error("销售人员没有指派!");
                return false;
            }

            //过滤销售人员的编码
            var product = _.find(this.salesmanList, {userName: this.salesManName});

            this.add.salesManCode = product.userCode;
            this.add.salesManName = product.userName;

            console.log("this.add",this.add)
            ss.BscClueZhaoBiao.designate(this.add).then(res => {
                if (res.f == true) {

                    this.$msg.alerts("提交成功！", () => {

                        if(this.add.fromSource =='RTB_91' || this.add.fromSource =='RTB_93'){
                            this.$router.push({ path: "/bscClueTabs", query: { type: "second"} });
                        }
                        if(this.add.fromSource =='PP_01' || this.add.fromSource =='PP_02'){
                            this.$router.push({ path: "/bscClueTabs", query: { type: "third"} });
                        }
                        if(this.add.fromSource =='MC_03' ){
                            this.$router.push({ path: "/bscClueTabs", query: { type: "fourth"} });
                        }
                        if(this.add.fromSource =='CH_01' ){
                            this.$router.push({ path: "/bscClueTabs", query: { type: "fifth"} });
                        }

                    })

                } else {
                    this.$message.error(res.msg);
                }
            })

        },


        /*承接操作*/
        undertake(trackStatus){

            this.$confirm(
                trackStatus === 1 ? '是否确认确认转为商机？' :  trackStatus === 2 ? '是否确认确认转为无效信息？' : '是否确认确认拒绝承接？' ,
                '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'

                })
                .then(_ => {
                    let query = {
                        id: this.id,
                        trackStatus: trackStatus,
                    }
                    ss.BscClueZhaoBiao.undertake(query).then(rd => {
                        if (rd.f == true) {
                            this.$msg.msgs('提交成功');

                            if(this.add.fromSource =='RTB_91' || this.add.fromSource =='RTB_93'){
                                this.$router.push({ path: "/bscClueTabs", query: { type: "second"} });
                            }
                            if(this.add.fromSource =='PP_01' || this.add.fromSource =='PP_02'){
                                this.$router.push({ path: "/bscClueTabs", query: { type: "third"} });
                            }
                            if(this.add.fromSource =='MC_03' ){
                                this.$router.push({ path: "/bscClueTabs", query: { type: "fourth"} });
                            }
                            if(this.add.fromSource =='CH_01' ){
                                this.$router.push({ path: "/bscClueTabs", query: { type: "fifth"} });
                            }


                        } else {
                            this.$msg.msge(rd.msg);
                        }
                    })

                })
                .catch(_ => {

                });
        },
    },

}
</script>
<style scoped lang="scss">
.y-container {
    width: 100%;

    .y_tabBar {
        display: flex;
        justify-content: flex-start;
        flex-wrap: nowrap;

        .eveBar {
            padding: 0.1rem 0.1rem 0.1rem 0.1rem;
            width: 1.85rem;
            height: 0.73rem;
            border: 1px solid #d9dfe9;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 0.16rem;
            position: relative;
            cursor: pointer;
            font-size: 0.18rem;
            color: #525252;

            &:last-child {
                margin-right: 0;
            }

            .imgrigt {
                margin-left: 0.08rem;
            }
        }

        .eveBarAc {
            background-color: #248bff;
            color: white;
        }

        .redCircle {
            width: 0.15rem;
            height: 0.15rem;
            background-color: #e64a19;
            position: absolute;
            top: -0.06rem;
            right: -0.06rem;
            border-radius: 50%;
        }
    }

    .containGrey {
        width: 100%;
        border: 1px solid #dedede;
        background-color: #f9f9f9;
        margin-top: 0.4rem;

        .containAll {
            padding: 0.3rem;
            max-height: 3.6rem;
            width: 100%;
            overflow-y: auto;
        }

        .dialogDiv {
            margin-bottom: 0.2rem;

            .timeTip {
                color: #999999;
                font-size: 0.14rem;
                width: 100%;
                text-align: center;
                margin-bottom: 0.18rem;
            }

            .firstTalk {
                display: flex;

                .leftname {
                    font-size: 0.18rem;
                    color: #2a2a2a;
                }

                .containTalk {
                    font-size: 0.16rem;
                    color: #5e5e5e;
                    border: 1px solid #dedede;
                    background-color: white;
                    width: 7.1rem;
                    border-radius: 5px;
                    margin-left: 0.3rem;
                    padding: 0.2rem;
                    word-break: break-word;
                }

                .containTalk2 {
                    background-color: #e8e7e7;
                    margin-right: 0.3rem;
                    word-break: break-word;
                }
            }

            .firstTalk2 {
                flex-direction: row-reverse;
            }
        }

        .replyBox {
            padding: 0.2rem;
            border-top: 1px solid #dedede;
            display: flex;
            background-color: white;

            .tips {
                font-size: 0.18rem;
                color: #0072ed;
                flex-shrink: 0;
                margin-right: 0.15rem;
            }

            .replyBar {
                position: relative;
                width: 100%;

                .relpyInput {
                    width: 100%;
                    height: 0.72rem;
                    border: none;
                    background-color: #FFFFFF;
                    outline: none;
                    padding: 0.08rem;
                    padding-top: 0.04rem;
                    resize: none;
                }

                .h-bgblueQ2 {
                    background-color: #2785e7;
                    color: white;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    height: 0.46rem;
                    width: 1.1rem;
                    padding: 0;
                }
            }
        }
    }

}

.loopClosed {
    width: 100%;
    display: flex;
    padding-bottom: 50px;
}

.loopClosed .loop {
    width: 30%;
    margin-left: 3%;
}

.loopClosed .loop:first-child {
    margin: 0;
}

.loopClosed .loop .title {
    font-size: 0.18rem;
    color: #0e75e9;
    font-weight: bold;
    border-left: 0.05rem solid #0e75e9;
    margin-bottom: 0.3rem;
    padding-left: 10px;
}

.loopClosed .loop .boxs {
    width: 100%;
    padding: 60px;
    box-sizing: border-box;
    border: 1px solid #e4e4e4;
    color: #868686;
    font-size: 0.16rem;
    margin-bottom: 0.3rem;
    border-radius: 3px;
}

.shenglue {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}

.loopClosed .loop .buttons {
    width: 145px;
    height: 55px;
    border: 1px solid #e4e4e4;
    border-radius: 3px;
    color: #323232;
    font-size: 0.16rem;
    text-align: center;
    line-height: 55px;
    margin-left: 50%;
    transform: translateX(-72px);
    cursor: pointer;
}
</style>
<style>

.weekplandetail35 .h-formbLine .el-form-item__label {
    width: 31%;
    text-align: right;
}

.weekplandetail35 .h-formbLine .el-form-item__content {
    width: 69%;
}

.weekplandetail35 .h-formbLine .h-elformWrap-2 {
    width: 33.333%;
    padding-right: 0.5rem
}
.weekplandetail35 .h-formbLine .h-elformWrap-6 {
    width: 100%;
    padding-right: 0.5rem
}

.weekplandetail35 .h-formbLine .h-elformWrap-1 {
    width: 100%;
    padding-right: 0.5rem
}

.weekplandetail35 .h-formbLine .h-elformWrap-1 .el-form-item__label {
    width: 9.7%;
}

.weekplandetail35 .h-formbLine .h-elformWrap-1 .el-form-item__content {
    width: 90.3%;
}
</style>
<style scoped lang="scss">
.bottomTip{
    position: absolute;
    left: 49.7%;
    bottom: 0.3rem;
    transform: translateX(-50%);
    z-index: 999999;
}
.newtext{
    font-size: 0.28rem;
    color: white;
    position: absolute;
    top:0.2rem;
    left: 50%;
    transform: translateX(-50%);
    font-weight: bold;
    text-shadow:1px 1px 4px #2785E7;
    z-index: 2;
}
.leaderBox{
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.4);
    position: fixed;
    z-index: 99999;
    overflow: hidden;
    top: 0;
    left: 0;
    .leaderbg{
        width: 100%;
        height: 100%;
    }
    .steps{
        position: absolute;
        z-index: 1;
    }
    .step1{
        top: 0;
        left: 0;
    }

    .stepbtn{
        width: 1.9rem;
        height: 0.6rem;
        border: 0.03rem solid #FFFFFF;
        background-color: rgba(0,0,0,0.1);
        border-radius: 5px;
        display: flex;
        justify-content: center;
        line-height: 0.5rem;
        position: absolute;
        z-index: 99;
        bottom: 0.65rem;
        left: 50%;
        transform: translateX(-50%);
        font-size: 0.27rem;
        letter-spacing: 2px;
        color: white;
        cursor: pointer;
    }
    .closeIt{
        width: 0.3rem;
        height: 0.3rem;
        position: absolute;
        top: 0.2rem;
        right: 0.2rem;
        cursor: pointer;
        z-index: 2;
    }
    .el-textarea__inner{
        height: 26px;
        overflow-y: auto;
        /* overflow-y: auto;兼容ie  */
    }
}
</style>
<style>

</style>
